import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import _omit from 'lodash/omit';

import DomainActions from './domain-actions';

const initialState = Immutable({
  isFetching: false,
  hasFetched: false,
  byId:       {},
});

const reducer = createReducer(on => {
  on([DomainActions.fetchDomains, DomainActions.fetchAvailableDomains], state => {
    return state.set('isFetching', true).set('hasFetched', false);
  });

  on([DomainActions.fetchDomainsFailure, DomainActions.fetchAvailableDomainsFailure], state => {
    return state.set('isFetching', false).set('hasFetched', true);
  });

  on(DomainActions.resetDomainList, state => {
    return state.set('byId', {});
  });

  on(DomainActions.removeDomain, (state, { domainId }) => {
    return state.set('byId', _omit(state.byId, domainId));
  });

  on([DomainActions.fetchDomainsSuccess, DomainActions.fetchAvailableDomainsSuccess], (state, { domains }) => {
    const byId = _.reduce(
      domains,
      (acc, domain) => {
        acc[domain.id] = domain;
        return acc;
      },
      {}
    );
    return state
      .set('isFetching', false)
      .set('byId', byId)
      .set('hasFetched', true);
  });
}, initialState);

export default reducer;
